export const SPECS = {
  'cal-calcitica-virgem': {
    label: 'Cal Virgem Calcítica',
    pdf: '/media/ESPECIFICACAO-PADRAO-CAL-CALCITICA-VIRGEM.pdf',
    anchor: '#cal-calcitica-virgem',
  },
  'cal-calcitica-hidratada': {
    label: 'Cal Hidratada Calcítica (Ca(OH)₂)',
    pdf: '/media/ESPECIFICACAO-PADRAO-CAL-CALCITICA-HIDRATADA.pdf',
    anchor: '#cal-calcitica-hidratada',
  },
  'cal-dolomitica-virgem': {
    label: 'Cal Virgem Dolomítica',
    pdf: '/media/ESPECIFICACAO-PADRAO-CAL-DOLOMITICA-VIRGEM.pdf',
    anchor: '#cal-dolomitica-virgem',
  },
  'cal-dolomitica-hidratada': {
    label: 'Cal Hidratada Dolomítica',
    pdf: '/media/ESPECIFICACAO-PADRAO-CAL-DOLOMITICA-HIDRATADA.pdf',
    anchor: '#cal-dolomitica-hidratada',
  },
} as const;

export type SpecKey = keyof typeof SPECS;
